import React from "react";
import { Container, Card } from "react-bootstrap";
import "./Experience.css";
import L_CL from "../assets/images/cl.avif";
import work from "../assets/images/work.svg";
import L_SAFE from "../assets/images/safe.jpg";

function Experience() {
  return (
    <div id="experience">
      <div className="section" style={{display: "flex", justifyContent: "center"}}>
        <img style={{margin: "10px"}} id="codeLogo" src={work} alt="logo"></img>
        <h1 style={{margin: "10px", marginTop: "25px", marginLeft: "-20px"}} className="text-center font-details-b pb-4">EXPERIENCE</h1>
      </div>
      <div className="experience-container">
        <Container>
            <Card className="card">
              <Card.Header
                as="h5"
                className="d-flex justify-content-center flex-wrap logo"
              >
                <Card.Img
                  variant="top"
                  className="img-resize"
                  src={L_SAFE}
                  alt="CL logo"
                />
              </Card.Header>
              <Card.Body className="d-flex justify-content-center flex-column">
                <div>
                  <Card.Title className="text-center">
                    Software Engineer
                  </Card.Title>
                </div>
                <div>
                  <Card.Text className="text-center style">
                    <strong>Division:</strong> Automations and Authentication Protocols
                    <br />
                    <br />
                    <strong>Technologies:</strong> Java, Springboot, Angular, NgRx, RxJS
                    and Jira
                    <br />
                    <strong>Duration:</strong> January 2024 - Present
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Container>
          <Container>
            <Card className="card">
              <Card.Header
                as="h5"
                className="d-flex justify-content-center flex-wrap logo"
              >
                <Card.Img
                  variant="top"
                  className="img-resize"
                  src={L_CL}
                  alt="CL logo"
                />
              </Card.Header>
              <Card.Body className="d-flex justify-content-center flex-column">
                <div>
                  <Card.Title className="text-center">
                    Software Engineer Intern
                  </Card.Title>
                </div>
                <div>
                  <Card.Text className="text-center style">
                    <strong>Division:</strong> Business Process and Automation
                    Team
                    <br />
                    <br />
                    <strong>Technologies:</strong> C#, .NET, Angular, NgRx, RxJS
                    and Azure
                    <br />
                    <strong>Duration:</strong> September 2022 - May 2023
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Container>
      </div>
      <div className="line"></div>
    </div>
  );
}

export default Experience;
